export const THEATER_LOADING = 'THEATER_LOADING';
export const THEATER_DETAIL = 'THEATER_DETAIL';
export const THEATER_ALL_MOVIES = 'THEATER_ALL_MOVIES';
export const THEATER_MOVIES = 'THEATER_MOVIES';
export const THEATER_DATE = 'THEATER_DATE';
export const THEATER_DATE_MENU = 'THEATER_DATE_MENU';
export const THEATER_SCHEDULE = 'THEATER_SCHEDULE';
export const THEATER_CLEAR = 'THEATER_CLEAR';
